import * as React from 'react';

import { staticPageConstants } from '../../../../../common/constants/staticPageConstants';

import renderStaticSection from '../../../_common/utils/renderStaticSection';

import type { InformationCategoryProps } from './information.category.props';

const InformationCategory: React.FC<InformationCategoryProps> = function(props) {
  const {
          current,
          data,
          expandedSections,
          isObservable,
          observer,
          toggleCollapse,
        } = props;

  const ref = React.createRef<HTMLElement>();

  const containerProps   = React.useMemo(() => {
    if (!current) {
      return {};
    }

    return {
      itemProp:  'acceptedAnswer suggestedAnswer',
      itemScope: true,
      itemType:  'http://schema.org/Answer',
    };
  }, [current]);
  const content          = React.useMemo(() => {
    try {
      return JSON.parse(data.description);
    } catch {
      return { SECTIONS: [] };
    }
  }, [data.description]);
  const descriptionProps = React.useMemo(() => {
    if (!current) {
      return {};
    }

    return {
      itemProp: 'text',
    };
  }, [current]);
  const sectionProps     = React.useMemo(() => {
    if (!current) {
      return {
        'data-nosnippet': true,
      };
    }

    return {
      itemProp:  'mainEntity',
      itemScope: true,
      itemType:  'http://schema.org/Question',
    };
  }, [current]);

  React.useEffect(() => {
    const element = ref.current;

    if (element && isObservable) {
      observer.current?.observe(element);
    }

    return () => {
      if (element && !isObservable) {
        observer.current?.unobserve(element);
      }
    };
  }, [isObservable]);

  return (
    <section
      className={'body'}
      ref={ref}
      data-alias={data.urlKey}
      {...sectionProps}
    >
      <meta
        content={data.label}
        itemProp={'name'}
      />
      <div {...containerProps}>
        <div {...descriptionProps}>
          {content.SECTIONS.map((section: any, index: number) => {
            if (section.COMPONENT === staticPageConstants.COMPONENTS.COLLAPSED_BLOCK.LABEL) {
              return renderStaticSection(section, index, {
                isOpen:   expandedSections.has(index),
                onToggle: () => toggleCollapse(data.id, index),
              });
            }

            return renderStaticSection(section, index);
          })}
        </div>
      </div>
    </section>
  );
};

export default InformationCategory;